import { Channel, Topic } from "../../constants/index.js";
import { PageContextUtils, MessageBrokerUtils } from "../../utils/index.js";
import React, { useCallback } from "react";
import { EmptyComponent } from "../common/EmptyComponent.js";
import Loadable from "react-loadable";
import { UserContextSelectors } from "../../redux/selectors/index.js";
import { useSelector } from "react-redux";
import { useFeature } from "../../hooks/index.js";
import { AppFeatures } from "../../constants/featureFlags.js";

const MiniCashierOnDemand = Loadable({
  loader: () =>
    import(/* webpackChunkName: "container/minicashier" */ "./MiniCashier.js"),
  loading: EmptyComponent
});

const { miniCashierUrl } = PageContextUtils.getUrlResourceData();

export const MiniCashier = props => {
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const isInMiniCashierFeature = useFeature(AppFeatures.MINI_CASHIER);

  const isMiniCashierEnabled = isInMiniCashierFeature && miniCashierUrl;

  if (!isAuthenticated || !isMiniCashierEnabled) return null;

  return <MiniCashierOnDemand {...props} />;
};

export const useMiniCashierCommunicationHandler = () => {
  const openCashier = useCallback(data => {
    MessageBrokerUtils.publish({
      channel: Channel.PAYMENT,
      topic: Topic.CTA_Cashier_Open,
      headers: {
        publisher: "UAA"
      },
      data: data
    });
  }, []);

  return { openCashier };
};
